import { TILE_SIZE } from '../consts';
export const loadImageInstantly = (url) => {
    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
            resolve(image);
        };
        image.onerror = () => {
            console.error('error loading image', url);
        };
        image.src = url;
    });
};
export const parseDziXML = (xmlText) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'application/xml');
    const metadata = xmlDoc.querySelector('Metadata');
    const tilesPerLevel = metadata?.querySelector('TilesPerLevel');
    const originalWidth = xmlDoc?.querySelector('Size')?.getAttribute('Width');
    const originalHeight = xmlDoc?.querySelector('Size')?.getAttribute('Height');
    console.log('parseDziXML', originalWidth, originalHeight);
    const levelsData = [];
    if (tilesPerLevel) {
        const levelElements = Array.from(tilesPerLevel.children);
        levelElements.forEach((levelElement) => {
            const levelName = levelElement.nodeName;
            const xTiles = levelElement?.querySelector('XTiles')?.textContent;
            const yTiles = levelElement?.querySelector('YTiles')?.textContent;
            const levelID = levelName.replace(/\D/g, '');
            if (levelID && xTiles && yTiles) {
                const width = +xTiles * TILE_SIZE[0];
                const height = +yTiles * TILE_SIZE[1];
                const layer = {
                    id: +levelID,
                    countX: +xTiles,
                    countY: +yTiles,
                    width: width,
                    height: height,
                };
                levelsData.push(layer);
            }
        });
    }
    else {
        console.error('TilesPerLevel element not found in the XML.');
    }
    const levelsDataSorted = levelsData.sort((a, b) => a.id - b.id);
    return {
        levelsData: levelsDataSorted,
        originalWidth: originalWidth ? +originalWidth : undefined,
        originalHeight: originalHeight ? +originalHeight : undefined,
    };
};
